<div>
  <div class="text-center">
    <div class="mb-2">
      <button type="button" class="btn btn-success me-2" (click)="processPrint()" [disabled]="printing">
        <i class="bi bi-printer"></i> print PDF <i *ngIf="printing" class="fas fa-spin fa-spinner"></i>
      </button>
      <button type="button" class="btn btn-primary m-2" (click)="processSaveImage()" [disabled]="saving">
        <i class="bi bi-image-fill"></i> save image <i *ngIf="saving" class="fas fa-spin fa-spinner"></i>
      </button>
    </div>
  </div>

  <div class="d-flex justify-content-center" *ngIf="invoice">
    <div class="a4-container" style="min-width: 0; min-height: 0; border: 1px solid #bbb;">
      <div id="a4" class="a4"
        style="width: 21cm; height: 29.7cm; padding: 1.5cm 2cm; background-color: #fff;color: black !important;">
        <div class="d-flex">
          <div class style="min-width: 0; max-width: 50%;">
            <div class style="height: 60px;">
              <img class [src]="logo" alt width height="60px" style="object-fit: contain;">
            </div>
            <div class="mt-3">
              <b class="me-2"> Agent name:</b> {{invoice.agent_down_name}}
            </div>
            <div class>
              <b class="me-2"> Contact Name:</b> {{invoice.agent_down_contact}}
            </div>
            <div class>
              <b class="me-2">Bill name:</b> {{invoice.inv_titie}}
            </div>
          </div>
          <div class="ms-auto text-end" style="min-width: 0; max-width: 50%;">
            <div class style="font-size: 30px; font-weight: 600;">Invoice</div>
            <div class="mt-2" style="font-size: 20px;">
              <b style="font-weight: 600;">Amount</b> {{invoice.inv_total | number: '1.2-2'}} Bath
            </div>
            <div class="mt-3">
              <b class="me-2">No.:</b> {{invoice.inv_code}}
            </div>
            <div class>
              <b class="me-2">Create dt.:</b> {{invoice.create_date | date: 'dd/MM/yyyy' }}
            </div>
            <div class>
              <b class="me-2">Due dt.:</b> {{invoice.inv_due_date | date: 'dd/MM/yyyy' }}
            </div>
          </div>
        </div>

        <table class="table table-bordered mt-3 mb-0">
          <thead>
            <tr>
              <th style="background-color: #dfdfdf;">#</th>
              <th style="background-color: #dfdfdf;" width="300px">Lists</th>
              <th style="background-color: #dfdfdf;">Amount</th>
              <th style="background-color: #dfdfdf;">Win/Lose 100%</th>
              <th style="background-color: #dfdfdf;">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of invoice.invoice_list; let i = index" id="tr{{i}}">
              <td> {{i+1}}</td>
              <td class="text-start">
                <div>
                  {{item.inv_list_name}}
                </div>
                <small>{{item.inv_list_detail}}</small>
              </td>
              <td class="text-end">
                {{item.inv_list_amount | number: '1.2-2'}}
                <small class="opacity-50 d-block">
                  {{item.inv_list_valid_amount | number: '1.2-2'}}
                </small>
              </td>
              <td class="text-end">
                <span
                  [ngClass]="{'text-primary': item.inv_list_winlose > 0 , 'text-danger': item.inv_list_winlose < 0}">
                  {{item.inv_list_winlose | number: '1.2-2'}}
                </span>
                <small class="opacity-50 d-block">
                  DISC. {{item.inv_list_discount | number: '1.2-2'}}
                </small>
              </td>
              <td class="text-end">
                <span [ngClass]="{'text-primary': item.inv_list_total > 0 , 'text-danger': item.inv_list_total < 0}">
                  {{ item.inv_list_total | number: '1.2-2'}}
                </span>
                <small class="d-block opacity-50" style="text-decoration: line-through;">
                  {{item.inv_list_winlose * -1 | number: '1.2-2'}}
                </small>
              </td>
            </tr>
            <tr>
              <td>
                <div id="stretch-full-td"></div>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3" rowspan="3" class="text-start" style="vertical-align: top;">
                <b>Note:</b> {{invoice.inv_note}}
              </td>
              <td colspan="1" class="text-end">Total price</td>
              <td colspan="2" class="text-end">
                <span [ngClass]="{'text-primary': invoice.inv_total > 0 , 'text-danger': invoice.inv_total < 0}">
                  {{(invoice.inv_total - invoice.inv_discount_total) | number: '1.2-2'}}
                </span>
              </td>
            </tr>
            <tr>
              <td colspan="1" class="text-end">Total discount</td>
              <td colspan="2" class="text-end"> {{invoice.inv_discount_total | number: '1.2-2'}} </td>
            </tr>
            <tr>
              <td colspan="1" class="text-end">Total price</td>
              <td colspan="2" class="text-end">
                <u style="font-size: 16px;"
                  [ngClass]="{'text-primary': invoice.inv_total > 0 , 'text-danger': invoice.inv_total < 0}">
                  {{invoice.inv_total | number: '1.2-2'}}
                </u>
              </td>
            </tr>
            <!-- <tr style="background-color: #dfdfdf;">
              <td colspan="100%"> {{invoice.inv_total | thaibaht}} </td>
            </tr> -->
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
